//TODO - prep work! Goal is to organize files better instead of user profile user update user etc. too confusing and way more confusing than user / permissions
import { useMemo, useState } from "react";
import {
  Checkbox,
  Icon,
  Input,
  Button,
  Popover,
  NoSearchResults,
} from "@alpaca/framework";
import { Collapse } from "antd";

import { sieveObjectByKeys } from "../../../utils/sieveObject";
import "./permission.styles.scss";

function UserPermission({ permissions = [], onChange }) {
  const [searchedPermissionGroup, setSearchedPermissionGroup] = useState("");
  const [selectedApps, setSelectedApps] = useState([]);

  const collapseItems = useMemo(() => {
    let filteredPermissions = permissions;

    if (selectedApps.length) {
      filteredPermissions = permissions.filter(
        (permissionGroup) =>
          (selectedApps.includes("General") &&
            permissionGroup.app_name === null) ||
          selectedApps.includes(permissionGroup.app_name)
      );
    }

    filteredPermissions = sieveObjectByKeys(
      filteredPermissions,
      searchedPermissionGroup,
      ["app_name", "permission_group_name"]
    );

    const groupedPerms = filteredPermissions.reduce(
      (appPermissionGroups, permissionGroup) => {
        const { app_name } = permissionGroup;
        let newAppName = app_name || "General";
        const permissionGroups =
          appPermissionGroups[newAppName]?.permissionGroups || [];
        const appIcon =
          appPermissionGroups[newAppName]?.appIcon ||
          permissionGroup.app_icon ||
          "app_loginportal";

        permissionGroups.push(permissionGroup);
        appPermissionGroups[newAppName] = { permissionGroups, appIcon };

        return appPermissionGroups;
      },
      {}
    );

    return Object.entries(groupedPerms).map(
      ([appName, { permissionGroups, appIcon }]) => ({
        key: appName,
        label: (
          <div className="user-settings__permission-collapse-label">
            {appIcon === "app_loginportal" ? (
              <Icon icon={appIcon} style={{ height: "25px", width: "25px" }} />
            ) : (
              <img
                src={
                  appIcon?.startsWith("data")
                    ? appIcon
                    : `data:image/svg+xml;base64,${appIcon}`
                }
                alt="Base64 SVG"
                title=""
                height={25}
                width={25}
              />
            )}
            <span style={{ marginLeft: "8px" }}>{appName}</span>
          </div>
        ),
        children: (
          <div className="user-settings__permission-collapse-options">
            {permissionGroups.map((permissionGroup) => (
              <Checkbox
                key={permissionGroup.permission_group_name}
                defaultChecked={permissionGroup.isGranted}
                onChange={(e) =>
                  handleChange(
                    permissionGroup.permission_group_name,
                    e.target.checked
                  )
                }
              >
                {permissionGroup.permission_group_name}
              </Checkbox>
            ))}
          </div>
        ),
      })
    );
  }, [permissions, searchedPermissionGroup, selectedApps]);

  const appOptions = useMemo(() => {
    const appNameSet = new Set(
      permissions.map((perm) => (!perm.app_name ? "General" : perm.app_name))
    );

    return Array.from(appNameSet).map((appName) => ({
      label: appName,
      value: appName,
    }));
  }, [permissions]);

  const handleChange = (permissionGroupName, isChecked) => {
    const permIndex = permissions.findIndex(
      (perm) => perm.permission_group_name === permissionGroupName
    );
    if (permIndex === -1) return;
    onChange(permIndex, isChecked);
  };

  return (
    <div className="user-settings__permission-container">
      {/* framework table header not customizable enough, so making simple one from scratch */}
      <header className="user-settings__permission-header">
        <h3>Permissions</h3>
        <div className="user-settings__permission-header-controls">
          <Input
            placeholder="Search"
            prefix={<Icon icon="search" />}
            allowClear
            onChange={(e) => setSearchedPermissionGroup(e.target.value)}
          />
          <Popover
            placement="bottomLeft"
            title="Filter by App"
            trigger="click"
            content={
              <div className="user-settings__permission-filters-container">
                <Checkbox.Group
                  className="user-settings__permission-filters"
                  value={selectedApps}
                  onChange={(values) => setSelectedApps(values)}
                  options={appOptions}
                />
                <Button
                  danger
                  onClick={() => setSelectedApps([])}
                  className="user-settings__permission-filters-clear"
                >
                  Clear
                </Button>
              </div>
            }
          >
            <Button
              icon={
                <Icon icon="filter" style={{ height: "20px", width: "20px" }} />
              }
            />
          </Popover>
        </div>
      </header>
      <div className="user-settings__permission-options">
        {permissions?.length !== 0 ? (
          collapseItems.length === 0 ? (
            <NoSearchResults />
          ) : (
            <Collapse expandIconPosition="end">
              {collapseItems.map((item) => (
                // if we upgrade antd version to >= 5.6.0, just pass collapseItems to Collapse items prop instead of using panel
                <Collapse.Panel
                  className="user-settings__permission-collapse-content"
                  header={item.label}
                  key={item.key}
                >
                  {item.children}
                </Collapse.Panel>
              ))}
            </Collapse>
          )
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </div>
  );
}

export default UserPermission;
